<template>
  <div class="mb-3">
    <h3>Buscar documentos relacionados</h3>
    <hr class="my-2" />
    <form @submit.prevent="searchDoc()">
      <div class="d-flex">
        <div class="row" style="flex: 1">
          <div class="col-6">
            <p class="text-xs font-weight-bold mb-0">
              Tipo *
            </p>
            <multiselect
              v-model="type"
              :options="types"
              label="name"
              track-by="id"
              placeholder="Tipo de documento"
              :allow-empty="false"
              :show-labels="false"
              class="small-multiselect"
            />
          </div>
          <div class="col-6">
            <p class="text-xs font-weight-bold mb-0">
              # de {{ type.name }} *
            </p>
            <base-input
              v-model="search"
              ref="searchInput"
              type="number"
              :placeholder="`# de ${type.name}`"
              inputClasses="input-group-alternative form-control-sm text-xs"
              class="mb-0"
            />
          </div>

        </div>
        <div class="align-self-end ml-4">
          <base-button 
            icon="fa fa-search" 
            size="sm"
            nativeType="submit"
            :disabled="!search || !type || searching"
          >
            Buscar
          </base-button>
        </div>

      </div>
    </form>
    <hr class="my-3">
    <div class="d-flex align-items-center justify-content-center" style="height: 300px;">
      <EmptySection v-if="showEmpty"/>
      <BaseLoader v-if="searching"/>
      <DocumentHistory 
        v-if="showDocs"
        v-show="!searching && !showEmpty"
        @result="onResult"
        ref="docHistory"
        :docNum="search"
        :table="type.id"
        allowClick
        class="w-100 h-100"
      />
    </div>
  </div>
</template>

<script>
import DocumentHistory from "@/components/DocumentHistory.vue";
import Multiselect from "vue-multiselect";
import EmptySection from "@/components/EmptySection.vue";
import BaseLoader from "@/components/BaseLoader.vue";
export default {
  components: {
    DocumentHistory,
    Multiselect,
    EmptySection,
    BaseLoader
  },
  data() {
    return {
      search: null,
      type: null,
      showDocs: false,
      showEmpty: false,
      searching: false,
      types: [
        { id: "OQUT", name: "Cotización" },
        { id: "ORDR", name: "Pedido" },
        { id: "ODLN", name: "Entrega" },
        { id: "OINV", name: "Factura" },
      ],
    };
  },
  methods: {
    searchDoc(){
      this.showDocs = false;
      this.searching = true;
      this.showEmpty = false;
      this.$nextTick(() => {
        this.showDocs = true;
      });
    },
    onResult(result){
      console.log("RESULT", result);
      this.searching = false;
      if(result.length){
        this.showEmpty = false;
      } else {
        this.showEmpty = true;
      }
      this.$nextTick(() => {
        this.$refs.searchInput.toFocus();
      });
    },
  },
  created() {
    this.type = this.types[1];
    this.showEmpty = true;
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.searchInput.toFocus();
    });
  },
};
</script>

<style lang="scss" scoped></style>
